export default __webpack_public_path__ + "static/media/logo.8aa9c780.svg";